function initBogosBundle(bundleData, bogosAddFunction) {
  // --- Logger ---
  var logEl = document.getElementById('bogos-custom-log');
  var logs = [];
  function log(msg, data) {
    var ts = new Date().toLocaleTimeString();
    logs.push('[' + ts + '] ' + msg);
    if (data) {
      try { logs.push(JSON.stringify(data, null, 2)); } catch(e) { logs.push(String(data)); }
    }
    if (logEl) {
      logEl.textContent = logs.join('\n');
      logEl.scrollTop = logEl.scrollHeight;
    }
    console.log('[BOGOS Custom] ' + msg, data || '');
  }

  // Toggle log visibility
  var toggleBtn = document.getElementById('bogos-toggle-log');
  if (toggleBtn) {
    toggleBtn.addEventListener('click', function() {
      var isHidden = logEl.style.display === 'none';
      logEl.style.display = isHidden ? 'block' : 'none';
      this.textContent = isHidden ? 'Hide Debug Log' : 'Show Debug Log';
    });
  }

  // --- State ---
  var currentStep = 1;
  var selections = {};
  var totalSteps = 2;
  var swiperInstance = null;
  var popupOpen = false;

  // --- DOM refs ---
  var bundleEl = document.getElementById('bogos-custom-bundle');
  var loadingEl = document.getElementById('bogos-custom-loading');
  var gridEl = document.getElementById('bogos-custom-grid');
  var subtitleEl = document.getElementById('bogos-custom-subtitle');
  var countEl = document.getElementById('bogos-custom-count');
  var priceEl = document.getElementById('bogos-custom-price');
  var btnNext = document.getElementById('bogos-btn-next');
  var btnCart = document.getElementById('bogos-btn-cart');
  var popupEl = document.getElementById('bogos-custom-popup');
  var popupItemsEl = document.getElementById('bogos-popup-items');
  var popupCloseBtn = document.getElementById('bogos-popup-close');
  var modalOverlay = document.getElementById('bogos-modal-overlay');
  var modalImagesEl = document.getElementById('bogos-modal-images');
  var modalBodyEl = document.getElementById('bogos-modal-body');
  var modalCloseBtn = document.getElementById('bogos-modal-close');
  var modalSwiperInstance = null;
  var stepTabs = document.querySelectorAll('.bogos-custom__step-tab');

  log('Initializing custom UI with bundle: ' + bundleData.title);

  // --- GA4 Analytics: view_bundle (fires once when section enters viewport) ---
  var viewBundleFired = false;
  var bundleObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting && !viewBundleFired) {
        viewBundleFired = true;
        var eventData = {
          bundle_name: bundleData.title || '',
          bundle_id: String(bundleData.id || ''),
          total_steps: totalSteps,
          product_count: bundleData.products ? bundleData.products.reduce(function(acc, g) {
            if (g && g.value && Array.isArray(g.value)) return acc + g.value.length;
            return acc;
          }, 0) : 0
        };
        console.log('[GA4 Debug] view_bundle fired:', eventData);
        // Publish via Shopify Customer Events
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish('view_bundle', eventData);
          console.log('[GA4 Debug] Shopify.analytics.publish("view_bundle") sent');
        } else {
          console.warn('[GA4 Debug] Shopify.analytics.publish not available — view_bundle not sent to customer events');
        }
        bundleObserver.disconnect();
      }
    });
  }, { threshold: 0.3 });
  bundleObserver.observe(bundleEl);

  // Set header info from section settings (data attributes), with fallbacks
  var settingTitle = bundleEl.dataset.bundleTitle || '';
  var settingSubtitle = bundleEl.dataset.bundleSubtitle || '';

  // Title is fully controlled by the merchant via section settings
  var titleText = settingTitle || 'Build Your Bundle';
  document.querySelector('.bogos-custom__title').textContent = titleText;
  subtitleEl.textContent = settingSubtitle || bundleData.description || '';

  // Figure out total steps
  totalSteps = bundleData.mix_items ? bundleData.mix_items.length : 2;

  // Read step labels from section settings using getAttribute to avoid dataset camelCase conversion issues
  // e.g. data-step-1-label has a digit before a hyphen which breaks dataset camelCase mapping
  var stepLabels = [];
  for (var s = 1; s <= 10; s++) {
    var lbl = bundleEl.getAttribute('data-step-' + s + '-label');
    if (lbl) stepLabels.push(lbl);
  }

  // Build step tabs dynamically
  var stepsContainer = document.querySelector('.bogos-custom__steps');
  stepsContainer.innerHTML = '';
  var checkSvg = '<svg class="bogos-custom__step-check" xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none"><path d="M16 1.11425L14.9441 0L5.68529 9.77146L1.05587 4.90716L0 6.02141L5.64465 12L5.68523 11.9786L5.70552 12L16 1.11425Z" fill="#262625"/></svg>';
  for (var i = 0; i < totalSteps; i++) {
    var stepNum = i + 1;
    var label = stepLabels[i] || ('Step ' + stepNum);
    var activeClass = stepNum === 1 ? ' bogos-custom__step-tab--active' : '';
    var tab = document.createElement('button');
    tab.className = 'bogos-custom__step-tab' + activeClass;
    tab.dataset.step = stepNum;
    tab.innerHTML = '<span class="bogos-custom__step-num-wrap"><span class="bogos-custom__step-num">' + stepNum + '</span></span>' +
      '<span class="bogos-custom__step-label">' + label + '</span>' +
      checkSvg;
    stepsContainer.appendChild(tab);
  }
  stepTabs = stepsContainer.querySelectorAll('.bogos-custom__step-tab');

  // --- Storefront API config (used for metafield fetches) ---
  var storefrontToken = bundleEl.dataset.storefrontToken || '';
  var apiVersion = bundleEl.dataset.apiVersion || '2026-01';
  var shopDomain = window.location.hostname;

  // --- Fetch "Variant Available Online" metafield for all bundle variants ---
  var variantOnlineStatus = {}; // { variantId: true/false }

  function fetchVariantAvailability() {
    if (!storefrontToken) {
      log('No storefront token — skipping variant_available_online fetch');
      return Promise.resolve();
    }

    // Collect all unique variant IDs from bundleData
    var variantIds = [];
    if (bundleData && bundleData.products) {
      bundleData.products.forEach(function(group) {
        if (group.type === 'config') return;
        if (group.value) {
          group.value.forEach(function(product) {
            product.variants.forEach(function(v) {
              if (variantIds.indexOf(v.id) === -1) variantIds.push(v.id);
            });
          });
        }
      });
    }

    if (variantIds.length === 0) return Promise.resolve();

    // Storefront API: query variant nodes with metafield
    // Batch in groups of 50 to stay within query limits
    var batches = [];
    for (var i = 0; i < variantIds.length; i += 50) {
      batches.push(variantIds.slice(i, i + 50));
    }

    log('Fetching variant_available_online for ' + variantIds.length + ' variants (' + batches.length + ' batch(es))');

    var chain = Promise.resolve();
    batches.forEach(function(batch, batchIndex) {
      chain = chain.then(function() {
        // Build nodes query with aliases
        var fields = batch.map(function(id, idx) {
          return 'v' + idx + ': node(id: "gid://shopify/ProductVariant/' + id + '") { ' +
            '... on ProductVariant { id metafield(namespace: "custom", key: "variant_available_online") { value } } }';
        }).join(' ');
        var query = '{ ' + fields + ' }';

        return fetch('https://' + shopDomain + '/api/' + apiVersion + '/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': storefrontToken
          },
          body: JSON.stringify({ query: query })
        })
        .then(function(r) { return r.json(); })
        .then(function(result) {
          if (result.data) {
            batch.forEach(function(id, idx) {
              var node = result.data['v' + idx];
              if (node && node.metafield && node.metafield.value) {
                var val = node.metafield.value.toLowerCase();
                // "false" or "False" means unavailable online
                variantOnlineStatus[id] = val !== 'false';
              }
              // If metafield is blank/missing, treat as available (default)
            });
          }
          log('Batch ' + (batchIndex + 1) + ' variant_available_online results:', variantOnlineStatus);
        });
      });
    });

    return chain.catch(function(err) {
      log('variant_available_online fetch error: ' + err.message + ' (proceeding without metafield check)');
    });
  }

  // Show the UI
  loadingEl.style.display = 'none';
  bundleEl.style.display = 'block';

  // Fetch variant availability metafields, then render step 1
  fetchVariantAvailability().then(function() {
    renderStep(1);
  });

  // --- Get products for a given mix item step ---
  function getProductsForStep(stepId) {
    if (!bundleData || !bundleData.products) return [];
    var allProducts = [];
    bundleData.products.forEach(function(group) {
      if (group.type === 'config') return;
      if (group.value) {
        group.value.forEach(function(product) {
          var hasStep = product.variants.some(function(v) {
            return v.mix_item_ids && v.mix_item_ids.indexOf(stepId) !== -1;
          });
          if (hasStep) {
            allProducts.push(product);
          }
        });
      }
    });
    return allProducts;
  }

  // --- Format price ---
  function formatPrice(price) {
    if (typeof price === 'string') return '$' + parseFloat(price).toFixed(2);
    return '$' + (price / 100).toFixed(2);
  }

  // --- Check if a variant is unavailable (handles various SDK data formats + metafield) ---
  function isVariantUnavailable(v) {
    if (v.available === false || v.available === 0 || v.available === 'false') return true;
    if (v.inventory_management && v.inventory_quantity !== undefined && v.inventory_quantity <= 0 && v.inventory_policy !== 'continue') return true;
    // Check "Variant Available Online" metafield (fetched via Storefront API)
    if (variantOnlineStatus.hasOwnProperty(v.id) && variantOnlineStatus[v.id] === false) return true;
    return false;
  }

  // --- Render a step's products ---
  function renderStep(step) {
    currentStep = step;
    var products = getProductsForStep(step);
    log('Rendering step ' + step + ' — ' + products.length + ' products');

    // Destroy existing Swiper before clearing
    if (swiperInstance) {
      swiperInstance.slider.destroy();
      swiperInstance = null;
    }
    gridEl.innerHTML = '';

    products.forEach(function(product) {
      var stepVariants = product.variants.filter(function(v) {
        return v.mix_item_ids && v.mix_item_ids.indexOf(step) !== -1;
      });
      if (stepVariants.length === 0) return;

      var card = document.createElement('div');
      card.className = 'bogos-custom__card';
      card.dataset.productId = product.id;

      var isSelected = selections[step] && selections[step].product.id === product.id;
      if (isSelected) card.classList.add('bogos-custom__card--selected');

      var selectedVariant = isSelected ? selections[step].variant : null;

      var imgSrc = product.thumbnail || (stepVariants[0].thumbnail ? stepVariants[0].thumbnail : '');
      if (imgSrc && imgSrc.startsWith('//')) imgSrc = 'https:' + imgSrc;
      if (imgSrc && !imgSrc.includes('width=')) {
        imgSrc += (imgSrc.includes('?') ? '&' : '?') + 'width=400';
      }

      // Build variant pills HTML — always show, even for single variant
      var variantOptionsHTML = '<div class="bogos-custom__variants">';
      stepVariants.forEach(function(v) {
        var isUnavailable = isVariantUnavailable(v);
        var activeClass = (selectedVariant && v.id === selectedVariant.id) ? ' bogos-custom__variant--active' : '';
        var availableClass = isUnavailable ? ' bogos-custom__variant--unavailable' : '';
        variantOptionsHTML += '<button class="bogos-custom__variant' + activeClass + availableClass + '" ' +
          'data-variant-id="' + v.id + '" data-product-id="' + product.id + '" data-price="' + v.price + '"' +
          ' data-available="' + (isUnavailable ? 'false' : 'true') + '"' +
          (isUnavailable ? ' disabled' : '') + '>' +
          v.title + '</button>';
      });
      variantOptionsHTML += '</div>';

      card.innerHTML =
        '<div class="bogos-custom__card-img">' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="' + product.title + '" loading="lazy">' : '<div class="bogos-custom__card-noimg">No image</div>') +
        '</div>' +
        '<div class="bogos-custom__card-info">' +
          '<div class="bogos-custom__card-title-row">' +
            '<h4 class="bogos-custom__card-title">' + product.title + '</h4>' +
            '<span class="bogos-custom__card-price" data-product-id="' + product.id + '">' + formatPrice((selectedVariant || stepVariants[0]).price) + '</span>' +
          '</div>' +
          variantOptionsHTML +
          '<button class="bogos-custom__see-details">See details</button>' +
        '</div>';

      var slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.appendChild(card);
      gridEl.appendChild(slide);
    });

    // Initialize Swiper slider
    var sliderContainer = document.querySelector('#bogos-custom-slider .swiper');
    if (sliderContainer && window.FoxTheme && window.FoxTheme.Carousel) {
      swiperInstance = new window.FoxTheme.Carousel(sliderContainer, {
        slidesPerView: 2,
        spaceBetween: 10,
        threshold: 10,
        touchRatio: 0.6,
        navigation: {
          prevEl: '#bogos-nav-prev',
          nextEl: '#bogos-nav-next'
        },
        breakpoints: {
          750: { slidesPerView: 4, spaceBetween: 16 },
          1281: { slidesPerView: 5, spaceBetween: 16 }
        }
      });
      swiperInstance.init();
    }

    // Bind variant pill clicks
    gridEl.querySelectorAll('.bogos-custom__variant').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var productId = parseInt(this.dataset.productId);
        var variantId = parseInt(this.dataset.variantId);
        var price = this.dataset.price;

        // Extra OOS safeguard — skip if variant is unavailable
        if (this.dataset.available === 'false' || this.disabled) return;
        var product = getProductsForStep(currentStep).find(function(p) { return p.id === productId; });
        var variant = product.variants.find(function(v) { return v.id === variantId; });
        if (!variant) return;

        var card = this.closest('.bogos-custom__card');

        // Clear active variant pills on ALL cards (not just this one)
        gridEl.querySelectorAll('.bogos-custom__variant--active').forEach(function(v) {
          v.classList.remove('bogos-custom__variant--active');
        });
        this.classList.add('bogos-custom__variant--active');

        // Re-activate the pill on previously selected cards from OTHER steps
        // (only clear pills for current step's cards)

        // Update displayed price
        var cardPriceEl = card.querySelector('.bogos-custom__card-price[data-product-id="' + productId + '"]');
        if (cardPriceEl) {
          cardPriceEl.textContent = formatPrice(price);
        }

        // Select this product+variant
        selections[currentStep] = { product: product, variant: variant };

        // Update card selected states
        gridEl.querySelectorAll('.bogos-custom__card').forEach(function(c) {
          c.classList.remove('bogos-custom__card--selected');
        });
        card.classList.add('bogos-custom__card--selected');

        updateSummary();
        log('Selected variant for step ' + currentStep, { product: product.title, variant: variant.title, price: variant.price });

        // On the last step, immediately update the step tab checkmark and swap buttons
        if (currentStep === totalSteps) {
          stepTabs.forEach(function(tab) {
            if (parseInt(tab.dataset.step) === currentStep) {
              if (selections[currentStep]) {
                tab.classList.add('bogos-custom__step-tab--done');
              } else {
                tab.classList.remove('bogos-custom__step-tab--done');
              }
            }
          });

          if (allStepsComplete()) {
            btnNext.style.display = 'none';
            btnCart.style.display = 'flex';
            btnCart.disabled = false;
          } else {
            btnNext.style.display = 'flex';
            btnCart.style.display = 'none';
            btnNext.disabled = true;
            btnNext.textContent = 'Select a product';
          }
        }
      });
    });

    // Bind card clicks (select/deselect)
    gridEl.querySelectorAll('.bogos-custom__card').forEach(function(card) {
      card.addEventListener('click', function(e) {
        // Don't trigger if clicking a variant pill or see-details
        if (e.target.closest('.bogos-custom__variant') || e.target.closest('.bogos-custom__see-details')) return;

        var productId = parseInt(this.dataset.productId);
        var product = getProductsForStep(currentStep).find(function(p) { return p.id === productId; });

        // Check if product has any available variants for this step
        var availableVariants = product.variants.filter(function(v) {
          return !isVariantUnavailable(v) && v.mix_item_ids && v.mix_item_ids.indexOf(currentStep) !== -1;
        });
        if (availableVariants.length === 0) return; // All variants OOS — don't allow selection

        // If already selected, deselect
        if (selections[currentStep] && selections[currentStep].product.id === productId) {
          delete selections[currentStep];
          this.classList.remove('bogos-custom__card--selected');
          // Clear active variant pill
          var activePill = this.querySelector('.bogos-custom__variant--active');
          if (activePill) activePill.classList.remove('bogos-custom__variant--active');
          log('Deselected for step ' + currentStep);
        } else {
          // Find the active variant pill, or auto-select the first available one
          var activeVariantBtn = this.querySelector('.bogos-custom__variant--active');
          var variantId = activeVariantBtn ? parseInt(activeVariantBtn.dataset.variantId) : null;
          var variant;

          if (variantId) {
            variant = product.variants.find(function(v) { return v.id === variantId; });
          }
          if (!variant) {
            var stepVariants = product.variants.filter(function(v) {
              return v.mix_item_ids && v.mix_item_ids.indexOf(currentStep) !== -1;
            });
            variant = stepVariants.find(function(v) { return !isVariantUnavailable(v); });
            if (!variant) return; // No available variants — don't select
          }

          // Clear all variant pills across all cards, then activate the selected one
          gridEl.querySelectorAll('.bogos-custom__variant--active').forEach(function(v) {
            v.classList.remove('bogos-custom__variant--active');
          });
          var pillToActivate = this.querySelector('.bogos-custom__variant[data-variant-id="' + variant.id + '"]');
          if (pillToActivate) pillToActivate.classList.add('bogos-custom__variant--active');

          selections[currentStep] = { product: product, variant: variant };

          gridEl.querySelectorAll('.bogos-custom__card').forEach(function(c) {
            c.classList.remove('bogos-custom__card--selected');
          });
          this.classList.add('bogos-custom__card--selected');
          log('Selected for step ' + currentStep, { product: product.title, variant: variant.title });
        }

        updateSummary();

        // On the last step, immediately update the step tab checkmark and swap buttons
        if (currentStep === totalSteps) {
          stepTabs.forEach(function(tab) {
            if (parseInt(tab.dataset.step) === currentStep) {
              if (selections[currentStep]) {
                tab.classList.add('bogos-custom__step-tab--done');
              } else {
                tab.classList.remove('bogos-custom__step-tab--done');
              }
            }
          });

          if (allStepsComplete()) {
            btnNext.style.display = 'none';
            btnCart.style.display = 'flex';
            btnCart.disabled = false;
          } else {
            btnNext.style.display = 'flex';
            btnCart.style.display = 'none';
            btnNext.disabled = true;
            btnNext.textContent = 'Select a product';
          }
        }
      });
    });

    // Bind see-details clicks
    gridEl.querySelectorAll('.bogos-custom__see-details').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var card = this.closest('.bogos-custom__card');
        var productId = parseInt(card.dataset.productId);
        var product = getProductsForStep(currentStep).find(function(p) { return p.id === productId; });
        openDetailsModal(product);
      });
    });

    // Update step tabs
    stepTabs.forEach(function(tab) {
      tab.classList.remove('bogos-custom__step-tab--active');
      if (parseInt(tab.dataset.step) === step) tab.classList.add('bogos-custom__step-tab--active');
      if (selections[parseInt(tab.dataset.step)]) {
        tab.classList.add('bogos-custom__step-tab--done');
      } else {
        tab.classList.remove('bogos-custom__step-tab--done');
      }
    });

    // Reset btnNext text and handler to defaults
    btnNext.textContent = 'Next step';
    btnNext.onclick = null;

    // Update buttons
    if (step < totalSteps) {
      btnNext.style.display = 'flex';
      btnCart.style.display = 'none';
      btnNext.disabled = !selections[step];
    } else {
      // Check if any step (including the current/last one) is incomplete
      var firstIncomplete = null;
      for (var i = 1; i <= totalSteps; i++) {
        if (!selections[i]) { firstIncomplete = i; break; }
      }
      if (firstIncomplete !== null) {
        // Not all steps done yet — show Next/select prompt, hide Add to Cart
        btnNext.style.display = 'flex';
        btnCart.style.display = 'none';
        if (firstIncomplete === step) {
          // Current step is incomplete — disable Next until a product is selected
          btnNext.disabled = true;
          btnNext.textContent = 'Select a product';
        } else {
          // A different step is incomplete — Next navigates there
          btnNext.disabled = false;
          btnNext.textContent = 'Next step';
          btnNext.onclick = function() { renderStep(firstIncomplete); };
        }
      } else {
        btnNext.style.display = 'none';
        btnCart.style.display = 'flex';
        btnCart.disabled = false;
      }
    }

    updateSummary();
  }

  // --- Step tab clicks ---
  stepTabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var step = parseInt(this.dataset.step);
      renderStep(step);
    });
  });

  // --- Next button ---
  btnNext.addEventListener('click', function() {
    if (currentStep < totalSteps && selections[currentStep]) {
      renderStep(currentStep + 1);
    }
  });

  // --- Check if all steps are complete ---
  function allStepsComplete() {
    for (var i = 1; i <= totalSteps; i++) {
      if (!selections[i]) return false;
    }
    return true;
  }

  // --- Update summary bar ---
  var savingEl = document.getElementById('bogos-custom-saving');

  function updateSummary() {
    var count = Object.keys(selections).length;
    // Update count text but preserve the chevron SVG
    var chevronSvg = countEl.querySelector('.bogos-custom__count-icon');
    countEl.textContent = count + ' of ' + totalSteps + ' products selected ';
    if (chevronSvg) countEl.appendChild(chevronSvg);

    var total = 0;
    for (var key in selections) {
      var price = selections[key].variant.price;
      if (typeof price === 'string') {
        total += parseFloat(price);
      } else {
        total += price / 100;
      }
    }

    var discount = bundleData && bundleData.discount && bundleData.discount[0]
      ? bundleData.discount[0].discount : null;

    priceEl.textContent = 'Total bundle price: $' + total.toFixed(2);

    if (savingEl) {
      if (discount && discount.type === 'percentage' && allStepsComplete()) {
        var discountAmount = total * (discount.value / 100);
        savingEl.textContent = 'Saving $' + discountAmount.toFixed(2);
        savingEl.classList.add('bogos-custom__saving--visible');
      } else {
        savingEl.textContent = '';
        savingEl.classList.remove('bogos-custom__saving--visible');
      }
    }

    if (currentStep === totalSteps) {
      btnCart.disabled = !allStepsComplete();
    }
    btnNext.disabled = !selections[currentStep];
  }

  // --- Product Details Modal ---

  function fetchMetafields(productId) {
    if (!storefrontToken) {
      console.warn('[BOGOS Custom] No storefront token — skipping metafield fetch');
      return Promise.resolve(null);
    }

    var gid = 'gid://shopify/Product/' + productId;
    var query = '{ product(id: "' + gid + '") {' +
      ' bestFor: metafield(namespace: "my_fields", key: "type_of_skin_pdp") { value }' +
      ' helpsWith: metafield(namespace: "my_fields", key: "helps_with_pdp") { value }' +
      ' texture: metafield(namespace: "my_fields", key: "texture_pdp") { value }' +
      ' starRating: metafield(namespace: "okendo", key: "StarRatingSnippet") { value }' +
      ' } }';

    console.log('[BOGOS Custom] Fetching metafields for product ID:', productId);
    console.log('[BOGOS Custom] GraphQL query:', query);

    return fetch('https://' + shopDomain + '/api/' + apiVersion + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontToken
      },
      body: JSON.stringify({ query: query })
    })
    .then(function(r) {
      console.log('[BOGOS Custom] Storefront API response status:', r.status);
      return r.json();
    })
    .then(function(result) {
      console.log('[BOGOS Custom] Storefront API full response:', JSON.stringify(result, null, 2));
      if (result.errors) {
        console.error('[BOGOS Custom] GraphQL errors:', result.errors);
      }
      if (result.data && result.data.product) {
        var p = result.data.product;
        console.log('[BOGOS Custom] Metafield values — bestFor:', p.bestFor, '| helpsWith:', p.helpsWith, '| texture:', p.texture, '| starRating:', p.starRating);
        var result = {};
        var metafields = {};
        if (p.bestFor && p.bestFor.value) metafields['Best for'] = p.bestFor.value;
        if (p.helpsWith && p.helpsWith.value) metafields['Helps with'] = p.helpsWith.value;
        if (p.texture && p.texture.value) metafields['Product texture'] = p.texture.value;
        if (Object.keys(metafields).length > 0) result.metafields = metafields;
        if (p.starRating && p.starRating.value) result.starRating = p.starRating.value;
        console.log('[BOGOS Custom] Parsed result:', result);
        return Object.keys(result).length > 0 ? result : null;
      }
      console.warn('[BOGOS Custom] No product data in response');
      return null;
    })
    .catch(function(err) {
      console.error('[BOGOS Custom] Metafield fetch error:', err.message);
      log('Metafield fetch error: ' + err.message);
      return null;
    });
  }

  function openDetailsModal(product) {
    modalOverlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    modalImagesEl.innerHTML = '<div class="bogos-custom__modal-loading">Loading...</div>';
    modalBodyEl.innerHTML = '';

    // Get product handle — try from BOGOS data, else slugify title
    var handle = product.handle;
    if (!handle) {
      handle = product.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    }

    log('Opening details modal for: ' + product.title + ' (handle: ' + handle + ')');

    // Fetch product JSON and metafields in parallel
    var productFetch = fetch('/products/' + handle + '.js')
      .then(function(r) {
        if (!r.ok) throw new Error('Product not found');
        return r.json();
      });

    var metafieldFetch = fetchMetafields(product.id);

    Promise.all([productFetch, metafieldFetch])
      .then(function(results) {
        renderModalContent(results[0], results[1]);
      })
      .catch(function(err) {
        log('Error fetching product details: ' + err.message);
        renderModalFallback(product);
      });
  }

  function renderModalContent(shopifyProduct, metafieldData) {
    var metafields = metafieldData && metafieldData.metafields ? metafieldData.metafields : null;
    var starRating = metafieldData && metafieldData.starRating ? metafieldData.starRating : null;
    // Destroy existing swiper
    if (modalSwiperInstance) {
      modalSwiperInstance.slider.destroy();
      modalSwiperInstance = null;
    }

    // --- Images ---
    var imagesHTML = '<div class="bogos-custom__modal-slider"><div class="swiper"><div class="swiper-wrapper">';
    var images = shopifyProduct.images || [];
    if (images.length > 0) {
      images.forEach(function(imgUrl) {
        if (imgUrl.startsWith('//')) imgUrl = 'https:' + imgUrl;
        imagesHTML += '<div class="swiper-slide"><img src="' + imgUrl + '" alt="' + shopifyProduct.title + '"></div>';
      });
    }
    imagesHTML += '</div></div>';
    imagesHTML += '<button class="bogos-custom__modal-nav bogos-custom__modal-nav--prev" id="bogos-modal-nav-prev" aria-label="Previous">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18L9 12L15 6" stroke="#262625" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>';
    imagesHTML += '<button class="bogos-custom__modal-nav bogos-custom__modal-nav--next" id="bogos-modal-nav-next" aria-label="Next">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 18L15 12L9 6" stroke="#262625" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>';
    imagesHTML += '</div>';
    modalImagesEl.innerHTML = imagesHTML;

    // Init image swiper
    var modalSliderEl = modalImagesEl.querySelector('.swiper');
    if (modalSliderEl && images.length > 1 && window.FoxTheme && window.FoxTheme.Carousel) {
      modalSwiperInstance = new window.FoxTheme.Carousel(modalSliderEl, {
        slidesPerView: 2,
        spaceBetween: 4,
        navigation: {
          prevEl: '#bogos-modal-nav-prev',
          nextEl: '#bogos-modal-nav-next'
        }
      });
      modalSwiperInstance.init();
    }

    // --- Body ---
    var bodyHTML = '';

    // Badge from tags
    var tags = shopifyProduct.tags || [];
    if (typeof tags === 'string') tags = tags.split(', ');
    var badgeTags = ['bestseller', 'new', 'best seller', 'best sellers', 'award winner'];
    tags.forEach(function(tag) {
      if (badgeTags.indexOf(tag.toLowerCase()) !== -1) {
        bodyHTML += '<span class="bogos-custom__modal-badge">' + tag + '</span>';
      }
    });

    // Title + star rating row
    bodyHTML += '<div class="bogos-custom__modal-title-row">';
    bodyHTML += '<h3 class="bogos-custom__modal-title">' + shopifyProduct.title + '</h3>';
    if (starRating) {
      bodyHTML += '<div class="bogos-custom__modal-rating" data-oke-star-rating data-oke-reviews-product-id="shopify-' + shopifyProduct.id + '">' + starRating + '</div>';
    }
    bodyHTML += '</div>';

    // Price
    bodyHTML += '<span class="bogos-custom__modal-price">' + formatPrice(shopifyProduct.price) + '</span>';

    // Description
    if (shopifyProduct.description) {
      bodyHTML += '<div class="bogos-custom__modal-desc">' + shopifyProduct.description + '</div>';
    }

    // Metafields table
    if (metafields) {
      bodyHTML += '<div class="bogos-custom__modal-meta"><div class="bogos-custom__modal-meta-inner">';
      for (var label in metafields) {
        bodyHTML += '<div class="bogos-custom__modal-meta-row">' +
          '<span class="bogos-custom__modal-meta-label">' + label + '</span>' +
          '<span class="bogos-custom__modal-meta-value">' + metafields[label] + '</span>' +
          '</div>';
      }
      bodyHTML += '</div></div>';
    }

    // View full details link
    var productUrl = shopifyProduct.url || ('/products/' + shopifyProduct.handle);
    bodyHTML += '<a class="bogos-custom__modal-link" href="' + productUrl + '">' +
      '<span>View full details</span>' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8H13M13 8L8.5 3.5M13 8L8.5 12.5" stroke="#262625" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</a>';

    modalBodyEl.innerHTML = bodyHTML;

    // Trigger Okendo to initialize the star rating widget
    if (starRating && window.okeReviewsWidgetOnsite) {
      window.okeReviewsWidgetOnsite.initStarRating();
    }
  }

  function renderModalFallback(product) {
    // Fallback with BOGOS data only
    if (modalSwiperInstance) {
      modalSwiperInstance.slider.destroy();
      modalSwiperInstance = null;
    }

    var imgSrc = product.thumbnail || '';
    if (imgSrc && imgSrc.startsWith('//')) imgSrc = 'https:' + imgSrc;
    modalImagesEl.innerHTML = imgSrc
      ? '<div class="bogos-custom__modal-slider"><img src="' + imgSrc + '" alt="' + product.title + '" style="width:100%;border-radius:8px;"></div>'
      : '';

    var price = product.variants && product.variants[0] ? product.variants[0].price : 0;
    modalBodyEl.innerHTML =
      '<h3 class="bogos-custom__modal-title">' + product.title + '</h3>' +
      '<span class="bogos-custom__modal-price">' + formatPrice(price) + '</span>' +
      '<p class="bogos-custom__modal-desc" style="color:var(--Text-Secondary,#6E6E6E);">Full product details could not be loaded.</p>';
  }

  function closeDetailsModal() {
    modalOverlay.style.display = 'none';
    document.body.style.overflow = '';
    if (modalSwiperInstance) {
      modalSwiperInstance.slider.destroy();
      modalSwiperInstance = null;
    }
  }

  // Modal close handlers
  modalCloseBtn.addEventListener('click', closeDetailsModal);
  modalOverlay.addEventListener('click', function(e) {
    if (e.target === modalOverlay) closeDetailsModal();
  });

  // --- Selected Products Popup ---
  function togglePopup(show) {
    popupOpen = typeof show === 'boolean' ? show : !popupOpen;
    popupEl.style.display = popupOpen ? 'block' : 'none';
    var chevron = countEl.querySelector('.bogos-custom__count-icon');
    if (chevron) {
      if (popupOpen) {
        chevron.classList.add('bogos-custom__count-icon--flipped');
      } else {
        chevron.classList.remove('bogos-custom__count-icon--flipped');
      }
    }
    if (popupOpen) renderPopupItems();
  }

  function renderPopupItems() {
    popupItemsEl.innerHTML = '';
    var hasItems = false;

    for (var step = 1; step <= totalSteps; step++) {
      if (!selections[step]) continue;
      hasItems = true;
      var sel = selections[step];
      var product = sel.product;
      var variant = sel.variant;

      var imgSrc = product.thumbnail || (variant.thumbnail ? variant.thumbnail : '');
      if (imgSrc && imgSrc.startsWith('//')) imgSrc = 'https:' + imgSrc;
      if (imgSrc && !imgSrc.includes('width=')) {
        imgSrc += (imgSrc.includes('?') ? '&' : '?') + 'width=100';
      }

      var originalPrice = variant.price;
      var discount = bundleData && bundleData.discount && bundleData.discount[0]
        ? bundleData.discount[0].discount : null;
      var discountedPrice = originalPrice;
      var showDiscount = false;

      if (discount && discount.type === 'percentage' && allStepsComplete()) {
        var rawPrice = typeof originalPrice === 'string' ? parseFloat(originalPrice) : originalPrice / 100;
        var discounted = rawPrice * (1 - discount.value / 100);
        showDiscount = true;
        discountedPrice = discounted;
      }

      var priceHTML = '';
      if (showDiscount) {
        priceHTML = '<span class="bogos-custom__popup-item-price--original">' + formatPrice(originalPrice) + '</span>' +
          '<span class="bogos-custom__popup-item-price--discounted">' + '$' + (typeof discountedPrice === 'number' ? discountedPrice.toFixed(2) : discountedPrice) + '</span>';
      } else {
        priceHTML = '<span class="bogos-custom__popup-item-price--current">' + formatPrice(originalPrice) + '</span>';
      }

      var item = document.createElement('div');
      item.className = 'bogos-custom__popup-item';
      item.dataset.step = step;
      item.innerHTML =
        '<div class="bogos-custom__popup-item-img">' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="' + product.title + '">' : '') +
        '</div>' +
        '<div class="bogos-custom__popup-item-info">' +
          '<span class="bogos-custom__popup-item-name">' + product.title + '</span>' +
          (variant.title && variant.title !== 'Default Title' ? '<span class="bogos-custom__popup-item-variant">' + variant.title + '</span>' : '') +
          '<div class="bogos-custom__popup-item-bottom">' +
            '<div class="bogos-custom__popup-item-prices">' + priceHTML + '</div>' +
            '<button class="bogos-custom__popup-item-remove" data-step="' + step + '">Remove</button>' +
          '</div>' +
        '</div>';

      popupItemsEl.appendChild(item);
    }

    if (!hasItems) {
      popupItemsEl.innerHTML = '<div class="bogos-custom__popup-empty">No products selected yet.</div>';
    }

    // Bind remove buttons
    popupItemsEl.querySelectorAll('.bogos-custom__popup-item-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var removeStep = parseInt(this.dataset.step);
        delete selections[removeStep];
        renderPopupItems();
        updateSummary();
        // Re-render current step to update card selected states
        renderStep(currentStep);
        // Re-open popup since renderStep closes it implicitly
        togglePopup(true);
      });
    });
  }

  // Toggle popup on count click
  countEl.addEventListener('click', function(e) {
    e.stopPropagation();
    togglePopup();
  });

  // Close popup on close button
  popupCloseBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    togglePopup(false);
  });

  // Close popup on click outside
  document.addEventListener('click', function(e) {
    if (popupOpen && !popupEl.contains(e.target) && !countEl.contains(e.target)) {
      togglePopup(false);
    }
  });

  // Close popup or modal on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (modalOverlay.style.display !== 'none') {
        closeDetailsModal();
      } else if (popupOpen) {
        togglePopup(false);
      }
    }
  });

  // --- Wait for cart to stabilize (BOGOS observers finish processing) ---
  function waitForCartStable(maxAttempts, interval) {
    maxAttempts = maxAttempts || 10;
    interval = interval || 500;
    var lastToken = null;

    function cartToken(cart) {
      return cart.item_count + ':' + cart.total_price + ':' + cart.items.length;
    }

    return new Promise(function(resolve) {
      var attempts = 0;
      function poll() {
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          var token = cartToken(cart);
          attempts++;
          log('Cart stability check ' + attempts + '/' + maxAttempts + ' — ' + token + (lastToken === token ? ' (stable)' : ' (changed)'));
          if (lastToken === token) {
            resolve();
          } else {
            lastToken = token;
            if (attempts >= maxAttempts) {
              log('Cart did not stabilize after ' + maxAttempts + ' attempts — proceeding anyway');
              resolve();
            } else {
              setTimeout(poll, interval);
            }
          }
        }).catch(function() {
          resolve();
        });
      }
      // Initial delay to let BOGOS observers start
      setTimeout(poll, 500);
    });
  }

  // --- Finish cart add: apply discount (after BOGOS observers settle), fetch cart, update UI, open drawer ---
  function finishCartAdd(discountCode) {
    log('Waiting for BOGOS observers to settle...');

    waitForCartStable().then(function() {
      var discountStep;
      if (discountCode) {
        // Apply discount as the LAST step, after BOGOS observers have settled
        log('Re-applying discount code after observer settle: ' + discountCode);
        var formData = new FormData();
        formData.append('discount', discountCode);
        discountStep = fetch('/cart/update.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(function(r) { return r.json(); })
        .then(function(updateResult) {
          log('Final discount apply — discount_codes: ' + JSON.stringify(updateResult.discount_codes) +
            ', total_discount: ' + updateResult.total_discount);
        });
      } else {
        discountStep = Promise.resolve();
      }

      discountStep.then(function() {
        // Collect section IDs the cart drawer needs
        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        // Fetch cart JSON and section HTML in parallel
        var cartFetch = fetch('/cart.js').then(function(r) { return r.json(); });
        var sectionsFetch = sectionsToBundle.length > 0
          ? fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ sections: sectionsToBundle })
            }).then(function(r) { return r.json(); })
          : Promise.resolve(null);

        return Promise.all([cartFetch, sectionsFetch]);
      })
      .then(function(results) {
        var cartJson = results[0];
        var sectionsResult = results[1];

        // Merge sections into cart JSON so the drawer can render
        if (sectionsResult && sectionsResult.sections) {
          cartJson.sections = sectionsResult.sections;
        }

        log('Final cart state — total_discount: ' + cartJson.total_discount + ', total_price: ' + cartJson.total_price);
        if (cartJson.items) {
          cartJson.items.forEach(function(item, i) {
            log('Cart item ' + i + ': ' + item.title + ' — price: ' + item.price + ', line_price: ' + item.line_price +
              ', discounts: ' + JSON.stringify(item.discounts) +
              ', discount_allocations: ' + JSON.stringify(item.discount_allocations) +
              ', properties: ' + JSON.stringify(item.properties));
          });
        }
        log('Sections available: ' + (cartJson.sections ? Object.keys(cartJson.sections).join(', ') : 'none'));

        if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
        }

        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.show === 'function') {
          cartDrawer.show(btnCart);
        }

        btnCart.textContent = 'Added!';
        isAddingBundle = false;
        setTimeout(function() {
          btnCart.textContent = 'Add Bundle to Cart';
          btnCart.disabled = false;
        }, 2000);
      })
      .catch(function(err) {
        log('finishCartAdd error: ' + err.message);
        btnCart.textContent = 'Added!';
        isAddingBundle = false;
        btnCart.disabled = false;
        setTimeout(function() {
          btnCart.textContent = 'Add Bundle to Cart';
        }, 2000);
      });
    });
  }

  // --- Listen for cart changes: split bundle qty > 1 and clean orphans ---
  var isAddingBundle = false;
  var isCorrectingCart = false; // Re-entry guard

  if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function(event) {
      if (isAddingBundle || isCorrectingCart) return;

      var cart = event && event.cart ? event.cart : null;
      if (!cart || !cart.items) return;

      // Detect bundle items
      var bundleItems = [];
      cart.items.forEach(function(item) {
        var props = item.properties;
        if (props && props._bogos_trigger_type === 'mix_match' && props._bogos_trigger) {
          bundleItems.push({
            key: item.key,
            variant_id: item.variant_id,
            quantity: item.quantity,
            trigger: props._bogos_trigger
          });
        }
      });

      if (bundleItems.length === 0) return;

      // Check 1: Bundle items with qty > 1 (need splitting)
      var itemsToSplit = bundleItems.filter(function(item) { return item.quantity > 1; });

      // Check 2: Orphaned bundle groups (incomplete)
      var groups = {};
      bundleItems.forEach(function(item) {
        var parts = item.trigger.split('_');
        var base = parts.slice(0, -1).join('_');
        if (!groups[base]) groups[base] = [];
        groups[base].push(item);
      });
      var orphanKeys = [];
      Object.keys(groups).forEach(function(base) {
        if (groups[base].length < totalSteps) {
          groups[base].forEach(function(item) {
            orphanKeys.push(item.key);
          });
        }
      });

      if (itemsToSplit.length === 0 && orphanKeys.length === 0) return;

      isCorrectingCart = true;
      var chain = Promise.resolve();

      // --- Quantity splits ---
      if (itemsToSplit.length > 0) {
        log('BUNDLE QTY SPLIT: Found ' + itemsToSplit.length + ' bundle items with qty > 1');
        itemsToSplit.forEach(function(item) {
          chain = chain.then(function() {
            var extraQty = item.quantity - 1;
            log('BUNDLE QTY SPLIT: resetting to qty 1, adding ' + extraQty + ' without bundle properties');
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 1 })
            }).then(function(r) { return r.json(); })
            .then(function() {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  items: [{ id: item.variant_id, quantity: extraQty }]
                })
              }).then(function(r) { return r.json(); });
            });
          });
        });
      }

      // --- Orphan cleanup ---
      if (orphanKeys.length > 0) {
        log('ORPHAN CLEANUP: Found ' + orphanKeys.length + ' orphaned items — stripping BOGOS properties');
        orphanKeys.forEach(function(key) {
          chain = chain.then(function() {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: key,
                properties: {
                  '_bogos_trigger_id': null,
                  '_bogos_trigger': null,
                  '_bogos_trigger_type': null
                }
              })
            }).then(function(r) { return r.json(); });
          });
        });
      }

      // --- Re-render the drawer, then refresh again after BOGOS observers settle ---
      chain.then(function() {
        log('CART CORRECTION: Complete — dispatching cart:refresh');
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        // After BOGOS observers settle, refresh drawer then update progress bar AFTER the re-render completes
        // cart:refresh triggers an async section fetch that replaces drawer HTML — we must wait for that
        // before touching progress bar DOM, otherwise our changes get overwritten
        setTimeout(function() {
          log('CART CORRECTION: Dispatching final cart:refresh');
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        }, 2000);
        // Wait for cart:refresh section fetch to complete (~1s), then update progress bar on the NEW DOM
        setTimeout(function() {
          log('CART CORRECTION: Updating progress bar after drawer re-render');
          fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
            var mrProgressBar = document.querySelector('.mr-progress-tier');
            var getTierData = document.querySelector('#progresstier_data');
            if (!mrProgressBar || !getTierData) return;
            var thresholds = [];
            if (getTierData.dataset.tier1Threshold) thresholds.push(parseInt(getTierData.dataset.tier1Threshold));
            if (getTierData.dataset.tier2Threshold) thresholds.push(parseInt(getTierData.dataset.tier2Threshold));
            if (getTierData.dataset.tier3Threshold) thresholds.push(parseInt(getTierData.dataset.tier3Threshold));
            if (thresholds.length === 0) return;
            var value = cart.total_price / 100;
            if (cart.total_price <= 0) { mrProgressBar.classList.add('hidden'); return; }
            mrProgressBar.classList.remove('hidden');
            var currentTier = 0;
            for (var i = 0; i < thresholds.length; i++) { if (value >= thresholds[i]) currentTier = i + 1; }
            var totalTiers = thresholds.length;
            var progressPercent = 0;
            if (currentTier === 0) progressPercent = 0;
            else if (currentTier === totalTiers) progressPercent = 100;
            else if (currentTier === 1) progressPercent = 5;
            else progressPercent = (currentTier / totalTiers) * 100;
            var progressFill = document.querySelector('.mr-progress-tier .progress-fill');
            var note = document.querySelector('.mr-progress-tier .progress-note');
            if (progressFill) progressFill.style.width = progressPercent + '%';
            document.querySelectorAll('.mr-progress-tier .step').forEach(function(step) {
              var tier = parseInt(step.dataset.tier);
              var threshold = thresholds[tier - 1];
              if (threshold !== undefined && value >= threshold) { step.classList.add('completed'); step.classList.remove('upcoming'); }
              else { step.classList.add('upcoming'); step.classList.remove('completed'); }
            });
            document.querySelectorAll('.mr-progress-tier .step-label').forEach(function(label) {
              var tier = parseInt(label.dataset.tier);
              var threshold = thresholds[tier - 1];
              if (threshold !== undefined && value >= threshold) label.style.opacity = '1';
            });
            if (note) {
              var nextThreshold = null;
              for (var j = 0; j < thresholds.length; j++) { if (value < thresholds[j]) { nextThreshold = thresholds[j]; break; } }
              if (nextThreshold !== null) {
                var diff = (nextThreshold - value).toFixed(2);
                var nextIndex = thresholds.indexOf(nextThreshold);
                var labelEl = document.querySelector('.mr-progress-tier .step-label[data-tier="' + (nextIndex + 1) + '"]');
                var labelText = labelEl ? labelEl.textContent : '';
                note.innerHTML = 'You are $' + diff + ' away from <strong>' + labelText.toUpperCase() + '</strong>';
              } else {
                note.innerHTML = '<strong>You\'ve unlocked all rewards!</strong>';
              }
            }
            log('CART CORRECTION: Progress bar updated — cart total $' + value);
          }).catch(function(err) { log('CART CORRECTION: Progress bar update failed — ' + err.message); });
          isCorrectingCart = false;
        }, 4000);
      })
      .catch(function(err) {
        log('CART CORRECTION: Error — ' + err.message);
        isCorrectingCart = false;
      });
    });
  }

  // --- Clean up orphaned bundle items before adding a new bundle ---
  function cleanOrphanedBundleItems() {
    log('=== ORPHAN CLEANUP: Fetching cart ===');
    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        // Find all items with BOGOS mix_match trigger properties
        var bundleItems = [];
        cart.items.forEach(function(item, index) {
          var props = item.properties;
          if (props && props._bogos_trigger_type === 'mix_match' && props._bogos_trigger) {
            bundleItems.push({
              index: index,
              key: item.key,
              title: item.title,
              trigger: props._bogos_trigger,
              triggerId: props._bogos_trigger_id
            });
          }
        });

        if (bundleItems.length === 0) {
          log('ORPHAN CLEANUP: No existing bundle items in cart');
          return Promise.resolve();
        }

        // Group by trigger base (everything before the last _mixId segment)
        // Trigger format: MM_{offerId}_{pageProductId}_{random}_{mixId}
        var groups = {};
        bundleItems.forEach(function(item) {
          // Extract base: everything up to the last underscore segment
          var parts = item.trigger.split('_');
          var base = parts.slice(0, -1).join('_');
          if (!groups[base]) groups[base] = [];
          groups[base].push(item);
        });

        log('ORPHAN CLEANUP: Found ' + bundleItems.length + ' bundle items in ' + Object.keys(groups).length + ' groups');
        Object.keys(groups).forEach(function(base) {
          log('  Group "' + base + '": ' + groups[base].length + ' items — ' +
            groups[base].map(function(i) { return i.title; }).join(', '));
        });

        // Find incomplete groups (less items than totalSteps)
        var orphanKeys = [];
        Object.keys(groups).forEach(function(base) {
          if (groups[base].length < totalSteps) {
            log('ORPHAN CLEANUP: Group "' + base + '" is incomplete (' + groups[base].length + '/' + totalSteps + ') — stripping BOGOS properties');
            groups[base].forEach(function(item) {
              orphanKeys.push(item.key);
            });
          }
        });

        if (orphanKeys.length === 0) {
          log('ORPHAN CLEANUP: No orphaned items found');
          return Promise.resolve();
        }

        // Strip BOGOS properties from orphaned items by updating them
        // Shopify /cart/change.js only handles one item at a time, so chain requests
        log('ORPHAN CLEANUP: Stripping BOGOS properties from ' + orphanKeys.length + ' orphaned items');
        var chain = Promise.resolve();
        orphanKeys.forEach(function(key) {
          chain = chain.then(function() {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: key,
                properties: {
                  '_bogos_trigger_id': null,
                  '_bogos_trigger': null,
                  '_bogos_trigger_type': null
                }
              })
            }).then(function(r) {
              log('ORPHAN CLEANUP: Cleared properties on item ' + key + ' — status: ' + r.status);
              return r.json();
            });
          });
        });
        return chain;
      })
      .catch(function(err) {
        log('ORPHAN CLEANUP: Error — ' + err.message + ' (proceeding with add anyway)');
      });
  }

  // --- Add to Cart ---
  btnCart.addEventListener('click', function() {
    if (!allStepsComplete()) return;

    btnCart.disabled = true;
    btnCart.textContent = 'Adding...';
    isAddingBundle = true;
    log('=== ADD TO CART ATTEMPT ===');

    var items = [];
    for (var step = 1; step <= totalSteps; step++) {
      var sel = selections[step];
      var mixItem = bundleData.mix_items ? bundleData.mix_items[step - 1] : null;
      var mixId = mixItem ? mixItem.id : step;
      log('Step ' + step + ': ' + sel.product.title + ' / ' + sel.variant.title + ' (id: ' + sel.variant.id + ', mix_id: ' + mixId + ')');
      items.push({
        id: sel.variant.id,
        quantity: 1,
        mix_id: mixId
      });
    }

    // Build _bogos_trigger value matching SDK format: MM_{offerId}_{pageProductId}_{random}
    var mmView = document.getElementById('bogos-mix-match-view');
    var pageProductId = mmView ? mmView.dataset.productId : '';
    var randomSuffix = Math.random().toString(36).substring(2, 7);
    var bogosTrigger = 'MM_' + bundleData.id + '_' + pageProductId + '_' + randomSuffix;

    log('bundleData.id: ' + bundleData.id);
    log('bundleData.code: ' + (bundleData.code || 'NONE'));
    log('Constructed _bogos_trigger base: ' + bogosTrigger);

    // Add items directly with correct BOGOS trigger properties (per BOGOS dev team fix)
    var cartItems = items.map(function(item) {
      return {
        id: item.id,
        quantity: item.quantity,
        properties: {
          '_bogos_trigger_id': bundleData.id,
          '_bogos_trigger': bogosTrigger + '_' + item.mix_id,
          '_bogos_trigger_type': 'mix_match'
        }
      };
    });

    // --- GA4 Analytics: add_bundle ---
    var bundleItems = [];
    var bundleTotalValue = 0;
    for (var ai = 1; ai <= totalSteps; ai++) {
      var aSel = selections[ai];
      var aPrice = typeof aSel.variant.price === 'string' ? parseFloat(aSel.variant.price) : aSel.variant.price / 100;
      bundleTotalValue += aPrice;
      bundleItems.push({
        product_title: aSel.product.title,
        variant_title: aSel.variant.title,
        variant_id: String(aSel.variant.id),
        price: aPrice.toFixed(2)
      });
    }
    var discount = bundleData && bundleData.discount && bundleData.discount[0]
      ? bundleData.discount[0].discount : null;
    var addBundleData = {
      bundle_name: bundleData.title || '',
      bundle_id: String(bundleData.id || ''),
      total_steps: totalSteps,
      total_value: bundleTotalValue.toFixed(2),
      discount_type: discount ? discount.type : 'none',
      discount_value: discount ? String(discount.value) : '0',
      items: bundleItems
    };
    console.log('[GA4 Debug] add_bundle fired:', addBundleData);
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish('add_bundle', addBundleData);
      console.log('[GA4 Debug] Shopify.analytics.publish("add_bundle") sent');
    } else {
      console.warn('[GA4 Debug] Shopify.analytics.publish not available — add_bundle not sent to customer events');
    }

    // Clean orphaned bundle items first, then add new bundle
    log('Starting orphan cleanup before adding new bundle...');
    cleanOrphanedBundleItems().then(function() {
      log('Adding items via /cart/add.js with BOGOS properties');
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: cartItems })
      });
    })
    .then(function(r) {
      if (!r.ok) {
        return r.json().then(function(err) {
          throw new Error(err.description || err.message || r.status);
        });
      }
      return r.json();
    })
    .then(function(addResult) {
      log('Cart add result:', addResult);

      // Pass discount code to finishCartAdd — it will wait for BOGOS observers
      // to settle before applying the discount as the final step
      var discountCode = bundleData.code || null;
      log('Deferring discount apply to finishCartAdd (code: ' + (discountCode || 'NONE') + ')');
      finishCartAdd(discountCode);
    })
    .catch(function(err) {
      log('Cart error: ' + err.message);
      btnCart.textContent = 'Error — try again';
      btnCart.disabled = false;
      isAddingBundle = false;
    });
  });
}
